module.exports = __webpack_public_path__ + "static/media/ipo-intelligence-logo-gold.76491b2c.png";